import { Route, Routes } from "react-router-dom";

 




import TecModeladoBim from "../newPages/tecnologiasnew/TecnologiaModeladoBim";
import TecNegociacion from "../newPages/tecnologiasnew/TecnologiaNegociacion";
import TecMarketing from "../newPages/tecnologiasnew/TecnologiaMarketingTuristico";
import TecCreacionOnline from "../newPages/tecnologiasnew/TecnologiaCreacionAudiovisual";
import TecContabilidad from "../newPages/tecnologiasnew/TecnologiaContabilidad";
import TecComunicacionEstrategica from "../newPages/tecnologiasnew/TecnologiaComunicacion";
function RoutesTec() {
  return (
    <>
 
        <Route
          path="/tecnologia-audiovisual-online"
          element={<TecCreacionOnline></TecCreacionOnline>}
        />
    
        <Route
          path="/tecnologia-contabilidad"
          element={<TecContabilidad></TecContabilidad>}
        />
        <Route
          path="/tecnologia-marketing-turistico"
          element={<TecMarketing></TecMarketing>}
        />
        <Route
          path="/tecnologia-modelado-bim"
          element={<TecModeladoBim></TecModeladoBim>}
        />
        <Route
          path="/tecnologia-negociacion-ventas"
          element={<TecNegociacion></TecNegociacion>}
        />
        <Route
          path="/tecnologia-comunicacion"
          element={<TecComunicacionEstrategica></TecComunicacionEstrategica>}
        />
 
    </>
  );
}

export default RoutesTec;
